import type { FaireProductEntity } from "../../entity_types/product";

export const p_k49jxsamfp: FaireProductEntity = {
  token: "p_k49jxsamfp",
  type: "product",
  name: "Miss Sparkling Mommy & Me Love Peace Knit Cardigan",
  brandToken: "b_erg8vzmjsk",
  brandName: "Miss Sparkling",
  imageUrl:
    "https://cdn.faire.com/fastly/ff1dc8038a90c4f048dc7b6b832d952eecc6b0c712ffde66ce13b4c97dd009c2.png",
  galleryImageUrls: [],
  priceDollars: 695.06,
  description:
    'Matching Family Style: Available in adult and child sizes for coordinated mommy-and-me looks \nStatement Back Design: Bold "LOVE" and "PEACE" lettering with a peace symbol knit on the back for a retro-inspired, eye-catching aesthetic\nPremium Chunky Knit: Crafted from soft, plush knit fabric for warmth, comfort, and a cozy, textured feel\nRelaxed Open-Front Silhouette: Oversized fit with dropped shoulders for a casual, effortless vibe; no fasteners for easy layering\nVersatile Wear: Ideal for layering over tees, dresses, or tops; perfect for family outings, photo ops, or everyday casual wear\n',
  tags: [],
  msrpDollars: 1390.12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:44.598Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
